import { LogLevel } from './../app/services/logger.service';
import { Environment } from './environment.interface';

/**
 * Default/Development environment configuration.
 * This file will be replaced during build process for other environments.
 */
export const environment: Environment = {
  name: 'development',
  production: false,
  apiUrl: 'http://localhost:5001/api',
  wsUrl: 'ws://localhost:5002',
  clearStorageOnStart: false,
  enableDebugLogging: true,
  logLevel: 'DBUG', // Refer: LogLevel type definition (DBUG, INFO, WARN, FAIL, NONE)
  apiTimeout: 30000, // 30 seconds
  wsTimeout: 10000,  // 10 seconds
  version: '0.0.3-dev',
  buildTime: new Date().toISOString(),
  // Phase 1: silent wait before showing the focus-loss reconnect modal (30 s default)
  focusLossDetectionMs: 30_000,
  // Pause before reconnect backend call to let the server expire the old session
  prepareVmDelayMs: 1000,
  features: {
    devTools: true,
    mockServices: false,
    analytics: false,
    errorReporting: false
  }
};
